import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ComplianceAuthTokenData } from '../models';

export interface ComplianceAuthTokenSliceState {
  data: ComplianceAuthTokenData;
  loading: boolean;
  error: string | null;
}

const initialState: ComplianceAuthTokenSliceState = {
  data: null,
  loading: false,
  error: null,
};

const complianceAuthTokenSlice = createSlice({
  name: 'complianceAuthToken',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<ComplianceAuthTokenData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
  },
});

export { complianceAuthTokenSlice };
